import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/node_modules/@codegouvfr/react-dsfr/Accordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["Alert"] */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/node_modules/@codegouvfr/react-dsfr/Alert.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/node_modules/next/dist/client/app-dir/link.js");
